import type { TrackEvent } from '../../core';
import type { CompiledParameters } from './parameter-types';
import { compileParameters } from './parameter-config';
import { systemDefaults } from './system-fields';

/** 唯一字段出口：标准名优先，未知属性不透传；新模式不补历史业务空值。 */
export function mapLegacyFields(event: TrackEvent, config: CompiledParameters = compileParameters()): Record<string, unknown> {
  const defaults = systemDefaults(event);
  const fields: Record<string, unknown> = Object.create(null);
  for (const field of config.fields) {
    const source = field.sources.find((key) =>
      Object.prototype.hasOwnProperty.call(event.properties, key)
      && event.properties[key] !== undefined && event.properties[key] !== null);
    const fallback = Object.prototype.hasOwnProperty.call(defaults, field.name) ? defaults[field.name] : field.defaultValue;
    const value = source === undefined ? fallback : event.properties[source];
    if (value != null || config.legacy) fields[field.name] = value ?? '';
  }
  // 历史模式的数据源为额外可选项；新模式需由宿主登记。
  if (config.legacy && event.properties._dataSource != null) fields._dataSource = event.properties._dataSource;
  return fields;
}
